import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

interface SkeletonProps {
  className?: string;
}
const Skeleton: FC<SkeletonProps> = ({ className }) => {
  return (
    <span className={twMerge('bg-gray-200 animate-pulse block', className)}>
      {/* to make skeleton able to inline with <li /> */}
      <span className="opacity-0 text-[1px]">.</span>
    </span>
  );
};

export default Skeleton;
